<template>
  <div v-if="tenderInfo" class="tender-summary-info-block spacey-40">
    <ConfirmDeclineWindow
      v-if="isNotInvitedIncomingTender"
      :is-declined="isDeclinedIncomingTender"
      :decline-loading="declineLoading"
      :declined-user="declinedUser"
      :confirm-loading="confirmLoading"
      :company-name="companyName"
      @confirm="confirmTender"
      @decline="declineTender"
    />
    <div class="spacey-20">
      <h5 class="h5">
        {{ tenderInfo.name }}
      </h5>
      <div class="tender-info text-sm">
        <span class="grey-600">{{ $t('Project') }}</span>
        <span class="grey-900">{{ incomingTenderInfo.tender.project.name }}</span>
        <span class="grey-600">{{ $t('Organizer') }}</span>
        <span class="grey-900">{{ incomingTenderInfo.tender.team.name }}</span>
        <span class="grey-600">{{ $t('Project stage') }}</span>
        <span class="grey-900">{{ projectStates[tenderInfo.project.state] }}</span>
        <span class="grey-600">{{ $t('Offer deadline') }}</span>
        <span class="grey-900">{{
          prettyDates(incomingTenderInfo.tender.offers_deadline_date)
        }}</span>
        <span class="grey-600">{{ $t('Construction start date') }}</span>
        <span class="grey-900">{{ prettyDates(incomingTenderInfo.tender.created_at) }}</span>
        <span class="grey-600">{{ $t('Last updated') }}</span>
        <span class="grey-900">{{ prettyDates(incomingTenderInfo.tender.updated_at, true) }}</span>
      </div>
    </div>
    <div class="spacey-20">
      <div v-if="tenderInfo.description" class="d-contents spacey-20">
        <h3 class="text text-black m-0 fs-20 fw-7">
          {{ $t('Description') }}
        </h3>
        <div class="info-block-description fs-16">
          {{ tenderInfo.description }}
        </div>
        <!--        TODO: more info-->
        <!--        <button class="btn-link">{{ $t('more info') }}</button>-->
      </div>
      <div class="info-row spacex-32">
        <div class="tender-info text-sm">
          <span class="grey-600">{{ $t('Execution place') }}</span>
          <span class="grey-900">{{ tenderInfo.project.address }}</span>
          <span class="grey-600">{{ $t('Expected price') }}</span>
          <span class="grey-900">
            {{ currencySymbols[incomingTenderInfo.currency] }}
            {{ incomingTenderInfo.tender.public_budget }}
          </span>
        </div>
      </div>
    </div>
    <div v-if="tenderInfo.contact_person_responsible_user" class="spacey-20">
      <h3 class="text text-black m-0 fs-20 fw-7">
        {{ $t('Contact person') }}
      </h3>
      <UserInfo :user="tenderInfo.contact_person_responsible_user" />
    </div>
    <div v-if="showOffersInfo" class="spacey-20">
      <h3 class="text text-black m-0 fs-20 fw-7">
        {{ $t('Our offers') }}
      </h3>
      <OffersTable :offers="incomingTenderInfo.versions" />
    </div>
    <div v-if="tenderInfo.files && tenderInfo.files.length" class="spacey-20">
      <h3 class="text text-black m-0 fs-20 fw-7">
        {{ $t('Files') }}
      </h3>
      <FilesTable :files="tenderInfo.files" />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex';
  import prettyDates from '@/utils/formatting/pretty-date';
  import UserInfo from '@/components/ui/UserInfo';
  import FilesTable from '@/containers/tender/tender-info/files-table/FilesTable';
  import get from 'lodash.get';
  import ConfirmDeclineWindow from '@/containers/tender/tender-info/ConfirmDeclineWindow';
  import request from '@/utils/api/request';
  import OffersTable from '@/containers/incoming-tender/OffersTable';
  import CreateOfferModal from '@/containers/incoming-tender/CreateOfferModal';

  export default {
    name: 'IncomingTenderInfo',
    components: {
      ConfirmDeclineWindow,
      UserInfo,
      FilesTable,
      OffersTable,
    },
    data() {
      return {
        declineLoading: false,
        confirmLoading: false,
        isFullDescription: false,
      };
    },
    computed: {
      ...mapState('global', ['currencySymbols']),
      ...mapState({
        tenderInfo: (state) => {
          return state.incomingTender.incomingTenderInfo.tender;
        },
        incomingTenderInfo: (state) => {
          return state.incomingTender.incomingTenderInfo;
        },
        projectStates: (state) => state.global.project_states,
        status: (state) => state.incomingTender?.incomingTenderInfo?.status || null,
      }),
      ...mapGetters({
        isNotInvitedIncomingTender: 'incomingTender/isNotInvitedIncomingTender',
        isDeclinedIncomingTender: 'incomingTender/isDeclinedIncomingTender',
      }),
      declinedUser() {
        return this.incomingTenderInfo?.contractor_declined_user || null;
      },
      companyName() {
        return this.incomingTenderInfo?.tender.team.name;
      },
      noOffers() {
        return get(this.incomingTenderInfo, 'versions.length', 0) === 0;
      },
      showOffersInfo() {
        return (
          this.incomingTenderInfo.status !== 'invited' &&
          this.incomingTenderInfo.status !== 'declined' &&
          !!this.incomingTenderInfo?.versions.length
        );
      },
    },
    methods: {
      prettyDates,
      get,
      ...mapActions('incomingTender', ['loadIncomingTenderInfo']),
      ...mapActions('modal', ['openModal']),
      async confirmTender() {
        this.openModal({
          component: CreateOfferModal,
        });
      },
      async declineTender() {
        this.declineLoading = true;
        try {
          const offerId = this.incomingTenderInfo?.id;
          await request.post(`/incoming_tenders/offers/${offerId}/decline/`);
          await this.loadIncomingTenderInfo(offerId);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
        this.declineLoading = false;
      },
    },
  };
</script>
